export const SERVICES_CONFIG = [
  {
    icon: "lucide:globe",
    collection: "domain_services",
    title: "Domain Services",
    formTitle: "Domain Service",
  },
  {
    icon: "lucide:settings",
    collection: "generic_services",
    title: "Generic Services",
    formTitle: "Generic Service",
  },
  {
    icon: "lucide:server",
    collection: "hosting_services",
    title: "Hosting Services",
    formTitle: "Hosting Service",
  },
  {
    icon: "lucide:megaphone",
    collection: "marketing_services",
    title: "Marketing Services",
    formTitle: "Marketing Service",
  },
  {
    icon: "lucide:smartphone",
    collection: "mobile_app_services",
    title: "Mobile App Services",
    formTitle: "Mobile App Service",
  },
  {
    icon: "lucide:monitor",
    collection: "monitoring_services",
    title: "Monitoring Services",
    formTitle: "Monitoring Service",
  },
  {
    icon: "lucide:thumbs-up",
    collection: "social_media_services",
    title: "Social Media Services",
    formTitle: "Social Media Service",
  },
  {
    icon: "lucide:layout-grid",
    collection: "website_services",
    title: "Website Services",
    formTitle: "Website Service",
  },
  {
    icon: "lucide:bar-chart",
    collection: "analytics_services",
    title: "Analytics Services",
    formTitle: "Analytics Service",
  },
  {
    icon: "lucide:code",
    collection: "application_development_services",
    title: "Application Development Services",
    formTitle: "Application Development Service",
  },
  {
    icon: "lucide:database",
    collection: "database_services",
    title: "Database Services",
    formTitle: "Database Service",
  },
  {
    icon: "lucide:mail",
    collection: "email_services",
    title: "Email Services",
    formTitle: "Email Service",
  },
  {
    icon: "lucide:bell",
    collection: "notification_services",
    title: "Notification Services",
    formTitle: "Notification Service",
  },
  {
    icon: "lucide:credit-card",
    collection: "payment_services",
    title: "Payment Services",
    formTitle: "Payment Service",
  },
  {
    icon: "lucide:hard-drive",
    collection: "server_services",
    title: "Server Services",
    formTitle: "Server Service",
  },
  {
    icon: "lucide:folder",
    collection: "storage_services",
    title: "Storage Services",
    formTitle: "Storage Service",
  },
  {
    icon: "lucide:zap",
    collection: "api_services",
    title: "API Services",
    formTitle: "API Service",
  },
];
